@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.sddamico.swigmore.pages.AdminPage as _com_sddamico_swigmore_pages_AdminPage
import com.sddamico.swigmore.pages.ArchivePage as _com_sddamico_swigmore_pages_ArchivePage
import com.sddamico.swigmore.pages.BallotPage as _com_sddamico_swigmore_pages_BallotPage
import com.sddamico.swigmore.pages.ComputerPollsPage as _com_sddamico_swigmore_pages_ComputerPollsPage
import com.sddamico.swigmore.pages.DesignSystemPage as _com_sddamico_swigmore_pages_DesignSystemPage
import com.sddamico.swigmore.pages.HomePage as _com_sddamico_swigmore_pages_HomePage
import com.sddamico.swigmore.pages.ResultsPage as _com_sddamico_swigmore_pages_ResultsPage
import com.sddamico.swigmore.pages.SigninPage as _com_sddamico_swigmore_pages_SigninPage
import com.sddamico.swigmore.pages.admin.AnnouncePage as _com_sddamico_swigmore_pages_admin_AnnouncePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Swigmore Poll"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_sddamico_swigmore_pages_HomePage()
        }
        ctx.router.register(
            "/admin",
        ) { pageCtx -> 
            _com_sddamico_swigmore_pages_AdminPage()
        }
        ctx.router.register(
            "/admin/announce",
        ) { pageCtx -> 
            _com_sddamico_swigmore_pages_admin_AnnouncePage()
        }
        ctx.router.register(
            "/archive",
        ) { pageCtx -> 
            _com_sddamico_swigmore_pages_ArchivePage()
        }
        ctx.router.register(
            "/ballot",
        ) { pageCtx -> 
            _com_sddamico_swigmore_pages_BallotPage()
        }
        ctx.router.register(
            "/computer-polls",
        ) { pageCtx -> 
            _com_sddamico_swigmore_pages_ComputerPollsPage()
        }
        ctx.router.register(
            "/design-system",
        ) { pageCtx -> 
            _com_sddamico_swigmore_pages_DesignSystemPage()
        }
        ctx.router.register(
            "/results",
        ) { pageCtx -> 
            _com_sddamico_swigmore_pages_ResultsPage()
        }
        ctx.router.register(
            "/signin",
        ) { pageCtx -> 
            _com_sddamico_swigmore_pages_SigninPage()
        }

        com.sddamico.swigmore.initKobweb(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("nav-slot", com.sddamico.swigmore.components.sections.NavSlotStyle)
        ctx.theme.registerStyle("account-slot", com.sddamico.swigmore.components.sections.AccountSlotStyle)
        ctx.theme.registerStyle("sync-chip", com.sddamico.swigmore.components.sections.SyncChipStyle)
        ctx.theme.registerStyle("pressable", com.sddamico.swigmore.ds.PressableStyle)
        ctx.theme.registerStyle("field-row", com.sddamico.swigmore.ds.FieldRowStyle)
        ctx.theme.registerStyle("skeleton", com.sddamico.swigmore.ds.feedback.SkeletonStyle)
        ctx.theme.registerStyle("skeleton-block", com.sddamico.swigmore.ds.feedback.SkeletonBlockStyle)
        ctx.theme.registerStyle("ai-button", com.sddamico.swigmore.ds.forms.AiButtonStyle)
        ctx.theme.registerStyle("reveal", com.sddamico.swigmore.ds.RevealStyle)
        ctx.theme.registerStyle("previous-ballot-beside", com.sddamico.swigmore.pages.PreviousBallotBesideStyle)
        ctx.theme.registerStyle("previous-ballot-above", com.sddamico.swigmore.pages.PreviousBallotAboveStyle)
        com.sddamico.swigmore.initColorMode(ctx)
        com.sddamico.swigmore.initTheme(ctx)
        com.sddamico.swigmore.ds.initSwBase(ctx)
        com.sddamico.swigmore.ds.initSwMotion(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.sddamico.swigmore.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
